import { useGetGrouppedAvailablePackages } from '@/hooks/useOfferPackage'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { OfferPackageSettingsFormTabs, type OfferPackageSettingsFormProps } from 'BrokerTsLib/src/dtos'
import { useEffect, useState } from 'react'
import { OfferSettingsModal } from './components/OfferSettingsModal'
import { OfferPackageSettingsFormAddons } from './OfferPackageSettingsFormAddons'
import { OfferPackageSettingsFormPackages } from './OfferPackageSettingsFormPackages'


export const OfferPackageSettingsForm = ({ onSuccess, onClose, offer, isOpen, title, isReadOnly, activeTab }: OfferPackageSettingsFormProps) => {

  const [tabIndex, setTabIndex] = useState(activeTab ?? OfferPackageSettingsFormTabs.addons)
  const handleTabsChange = (index: number) => {
    setTabIndex(index)
  }

  useEffect(() => {
    setTabIndex(activeTab ?? OfferPackageSettingsFormTabs.addons)
  }, [activeTab])

  const submitCallback = () => {
    onSuccess?.()
    onClose()
  }

  const groupedAvailablePackages = useGetGrouppedAvailablePackages(offer.offerId)
  const hasAnyPackageToChange = Object.values(groupedAvailablePackages).some(group => group.length > 1)

  return (
    <OfferSettingsModal
      title={title}
      isOpen={isOpen}
      isReadOnly={isReadOnly}
      onClose={onClose}
    >
      <Tabs
        onChange={handleTabsChange}
        index={tabIndex}
      >
        <TabList>
          <Tab>Připojištění</Tab>

          {hasAnyPackageToChange &&
            <Tab>Balíčky</Tab>
          }
          {/* <Tab>Slevy</Tab> */}
        </TabList>

        <TabPanels>
          <TabPanel>
            {tabIndex == OfferPackageSettingsFormTabs.addons && <OfferPackageSettingsFormAddons offer={offer} isReadOnly={isReadOnly} submitCallback={submitCallback} />}
          </TabPanel>

          <TabPanel>
            {tabIndex == OfferPackageSettingsFormTabs.packages && <OfferPackageSettingsFormPackages offer={offer} isReadOnly={isReadOnly} submitCallback={submitCallback} />}
          </TabPanel>

          {/* <TabPanel>
                {tabIndex == OfferPackageSettingsFormTabs.discounts && <Box>Index 2</Box>}
              </TabPanel> */}
        </TabPanels>
      </Tabs>
    </OfferSettingsModal>
  )
}